import { GET_SEARCHED_TERMS } from '../../constants/ActionTypes';

/**
 * Get the most searched terms for the autocomplete in SearchWidget.
 * @function getSearchedTerms
 * @returns {Object} Get the most searched terms
 */
export function getSearchedTerms() {
  return {
    type: GET_SEARCHED_TERMS,
    request: {
      op: 'get',
      path: '/@searched-terms',
    },
  };
}
